export enum FontWeight {
  Thin = "Thin",
  Extralight = "Extralight",
  Light = "Light",
  Normal = "Normal",
  Medium = "Medium",
  Semibold = "Semibold",
  Bold = "Bold",
  Extrabold = "Extrabold",
  Black = "Black",
}

export enum TypePaintingMessage {
  Classic = "Classic",
  OnlyHeader = "OnlyHeader",
}

export enum StyleBackgroundMessage {
  WithoutBackground = "WithoutBackground",
  OnlyHeader = "OnlyHeader",
  HeaderAndMessage = "HeaderAndMessage",
}

export enum TypeRankPlayerFormat {
  Text = "text",
  Digits = "digits",
  Text_Digits = "text+digits",
}
